var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraCardIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1389_9490)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1389_9490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.24023 5.77642V14.395C3.24023 14.8277 3.59102 15.1785 4.02374 15.1785H10.2918H14.6166H16.5598C16.9925 15.1785 17.3433 14.8277 17.3433 14.395V9.85064V5.77642C17.3433 5.34371 16.9925 4.99292 16.5598 4.99292H10.2918H5.00312H4.02374C3.59102 4.99292 3.24023 5.34371 3.24023 5.77642Z",
    fill: "url(#paint0_linear_1389_9490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72423 10.6372L4.91693 12.629C4.57429 13.0066 4.84221 13.6115 5.3521 13.6115H16.2141C16.724 13.6115 16.9919 13.0066 16.6493 12.629L13.177 8.80239C12.9438 8.5454 12.5399 8.5454 12.3067 8.80239L9.55334 11.8367C9.32014 12.0937 8.91619 12.0937 8.68299 11.8367L7.59458 10.6372C7.36138 10.3802 6.95743 10.3802 6.72423 10.6372Z",
    fill: "url(#paint1_linear_1389_9490)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.80193,
    cy: 8.2249,
    r: 1.07732,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1389_9490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.81607 6.79719C5.81607 6.79719 7.75713 5.82665 7.75713 4.37085V2.67242L5.81607 1.94452L3.875 2.67242V4.37085C3.875 5.82665 5.81607 6.79719 5.81607 6.79719Z",
    fill: "url(#paint2_linear_1389_9490)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 13.3281,
    y: 7.51129,
    width: 6.06583,
    height: 9.09875,
    rx: 0.909875,
    fill: "url(#paint3_linear_1389_9490)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.3574,
    cy: 15.6077,
    r: 0.460889,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1389_9490",
    x: 3.0915,
    y: 1.94452,
    width: 5.44982,
    height: 6.41967,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.783504
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.391752
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.386108 0 0 0 0 0.344377 0 0 0 0 0.866016 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1389_9490"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1389_9490",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1389_9490",
    x1: 2.73937,
    y1: 6.45126,
    x2: 17.4033,
    y2: 19.0564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E372FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1389_9490",
    x1: 10.7831,
    y1: 8.32281,
    x2: 10.7831,
    y2: 13.6115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1389_9490",
    x1: 5.81607,
    y1: 1.94452,
    x2: 5.81607,
    y2: 6.79719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32FF84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DC0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1389_9490",
    x1: 16.361,
    y1: 7.51129,
    x2: 16.361,
    y2: 16.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC6DFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1389_9490"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.8041,
    height: 18.8041,
    fill: "white",
    transform: "translate(0.742188 0.535522)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1389_9490"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.24219,
    y: 4.99292,
    width: 14.1031,
    height: 10.1855,
    rx: 0.783504,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraCardIcon3);
export default __webpack_public_path__ + "static/media/camera_card_icon3.cb91eabc942c29414ddc29d7465b9578.svg";
export { ForwardRef as ReactComponent };